// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__7YtVE","news-content":"News_news-content__OFcwM","news-content-title":"News_news-content-title__ii7WO"};